import React from "react";
import { PageHero, Section } from "./_shared";
import { useMitsol } from "./MitsolLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBody() {
  const data = useMitsol();
  const list = data?.executive_body || [];
  return (
    <div data-testid="mitsol-executive-body">
      <PageHero
        eyebrow="About"
        title="Executive Body Members"
        sub="The Executive Body of Gramaudyogik Shikshan Mandal — providing strategic direction and governance across all member institutions."
      />
      <Section>
        <BodyMembersTable members={list} theme="orange" testidPrefix="mitsol-eb" />
      </Section>
    </div>
  );
}
